import { t } from "@/i18n-js/instance";
import type { ConversationChannel } from "../../types/ConversationChannel";
import { ConversationClosedCta } from "../ConversationClosedCta";

interface ConversationClosedFooterProps {
  channel: ConversationChannel | null;
  sunshineConversationId?: string | null;
}

export const ConversationClosedFooter = ({
  channel,
  sunshineConversationId,
}: ConversationClosedFooterProps) => (
  <div className="bg-primary sticky bottom-0 z-10 rounded-b-2xl p-4">
    <ConversationClosedCta
      title={t("help_widget.conversation_page.conversation_closed_cta_title")}
      buttonLabel={t(
        "help_widget.conversation_page.conversation_closed_cta_button_label",
      )}
      subtitle={
        channel === "live_chat" && sunshineConversationId != null
          ? t("help_widget.conversation_page.conversation_closed_cta_subtitle")
          : undefined
      }
    />
  </div>
);
